// @ts-nocheck
(function () {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (search, replacement) {
            return this.replace(new RegExp(search, 'g'), replacement);
        };
    }
    if (!Object.hasOwn) {
        Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
    }
})();
